import { INACTIVE_PATIENT_LIST, SET_TOTAL_COUNT } from "../actions/inactivePatients.action";

const INITIAL_STATE = {
   inactivePatients: {
      list: [],
      totalCount: 0,
   },
   totalCount: 0,
};

export default function inactivePatientlist(state = INITIAL_STATE, action) {
   switch (action.type) {
      case INACTIVE_PATIENT_LIST:
         return {
            ...state,
            inactivePatients: action.payload,
         };
      case SET_TOTAL_COUNT:
         return {
            ...state,
            totalCount: action.payload.totalCount,
         };
      default:
         return state;
   }
}
